import ImageCropOriginal from '@mui/icons-material/CropOriginal';
import CanvasList from './CanvasList';
import { CanvasShow } from './ShowCanvas';

export default {
      list: CanvasList,
      show: CanvasShow,
      icon: ImageCropOriginal,
}